module.exports = __webpack_public_path__ + "09f3280d2f23aa573c15e3150d550a91.svg";